import React, { useEffect, useState } from "react";
import { Stack } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import { connect } from "react-redux";

import { PageContent } from "../../components";
import { getUserLocation } from "../../redux";

import ReportsSideBar from "./ReportsSideBar";
import ReportsPageContent from "./ReportsPageContent";
import { useReportsList } from "./helper";

const mapStateToProps = (state) => ({
  defaultLocation: getUserLocation(state),
});

export const ReportsPage = connect(mapStateToProps)(
  ({ defaultLocation = 1 }) => {
    const [searchParams, setSearchParams] = useSearchParams();

    const report = searchParams.get("report");
    const localStorageId =
      localStorage && localStorage.getItem("Report-View");

    const { reports: tabs, isLoading } = useReportsList({ locationId: defaultLocation });
    const defaultTab = tabs?.length ? tabs[0] : null;

    const defaultId = localStorageId || report || defaultTab?.id;
    const [value, setValue] = useState(Number(defaultId));

    const updateSearchParams = (id) => {
      const search = Object.fromEntries(searchParams.entries())
      const params = { ...search, report: id };
      localStorage && localStorage.setItem("Report-View", id);
      setSearchParams(params);
    }

    const onSetValue = (id) => {
      const tab = tabs?.find((tab) => tab.id === id);
      if (!tab?.id) return;

      updateSearchParams(id);
      setValue(Number(id));
    };

    useEffect(() => {
      updateSearchParams(value);
    }, [value]);

    const selected = tabs?.find(({ id }) => id === Number(value)) || defaultTab;

    return (
      <PageContent isLoading={isLoading} disablePadding>
        <Stack direction="row" height="100%" overflow="hidden">
          <ReportsSideBar {...{ value: Number(value), setValue: onSetValue, tabs }} />
          <ReportsPageContent
            url={selected?.url}
            locationId={defaultLocation}
          />
        </Stack>
      </PageContent>
    );
  }
);

export default ReportsPage;
